import {Brick, registerBrick} from 'olympe';

/**
 * This brick builds the structure for Olympe Gateway create body with specific data and filters.
 */
export default class OGCreateWriteEndpointBody extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} dataToInsert
     * @param {function({data: []})} setBody
     */
    update($, [dataToInsert], [setBody]) {
        setBody({
            data: [
                dataToInsert,
            ],
        });
    }
}

registerBrick('019c23d6eee0ca02b70f', OGCreateWriteEndpointBody);
